import CategorySearch from 'marketing/components/CategorySearch';
import CategoriesView from 'marketing/components/CategoriesView';
import FullTextSearch from 'marketing/utils/FullTextSearch';
import { trackLink, trackEvent } from '@99designs/common/utils/platform';
import CategoriesMenu from 'marketing/components/CategoriesMenu';
import { scrollOnHover } from 'marketing/components/scrollable';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';
import ScrollToElement from './components/ScrollToElement';
import SlideCarousel from './components/slide-carousel';

document.addEventListener('DOMContentLoaded', () => {
    const categoriesView = document.querySelector('[data-categories-view]');

    new CategoriesView(categoriesView);
    new CategorySearch({
        searcher: initializeSearcher(),
        onChange: () => {
            updateColor();
            initializeModals();
        },
    });
    new CategoriesMenu({ onChange: updateColor });

    initializeLinkTracking(categoriesView);
    runScrollable();
    initializeModals();
    initializeCarousel();
});

function initializeSearcher() {
    const searchConfig = [
        {
            name: 'title',
            weight: 0.8,
        },
        {
            name: 'parent',
            weight: 0.4,
        },
        {
            name: 'keywords',
            weight: 0.2,
        },
    ];
    const searchdocuments = readCategoriesData();
    const fallBackResult = searchdocuments
        .filter(doc => {
            return doc.key === 'other-design';
        })
        .pop();

    return new FullTextSearch(searchdocuments, searchConfig, fallBackResult);
}

function readCategoriesData() {
    const categories = [];

    window.categories.forEach(category => {
        const categoryNode = document.querySelector(`[data-category-${category.key}]`);

        if (categoryNode) {
            const clone = categoryNode.cloneNode(true);
            initializeLinkTracking(clone);

            categories.push({
                title: category.title,
                parent: category.parent_category_title,
                keywords: category.keywords.join(' '),
                node: clone,
                key: category.key,
            });
        }
    });

    return categories;
}

function initializeLinkTracking(element) {
    const categoryLinks = element.querySelectorAll('[data-categories-cta]');

    Array.from(categoryLinks).forEach(categoryLink => {
        categoryLink.addEventListener('click', trackClickedLink);
    });
}

function trackClickedLink(event) {
    const searchBox = document.querySelector('[data-search-field]');

    trackEvent('Clicked CTA on Categories Page', {
        cta_category: event.currentTarget.getAttribute('data-categories-cta-category'),
        cta_location: event.currentTarget.getAttribute('data-categories-cta-location'),
        searchTerm: searchBox ? searchBox.value : null,
    });
}

function runScrollable() {
    scrollOnHover();
}

function initializeModals() {
    const modals = document.querySelectorAll('[data-fullscreen-overlay-id]');

    Array.from(modals).forEach(
        modal =>
            new FullscreenOverlay({
                element: modal,
                options: {
                    fixedViewport: true,
                    onClose: () =>
                        trackEvent('Dismissed Categories Product Selection Modal', {
                            fullscreen_overlay_id: modal.getAttribute('data-fullscreen-overlay-id'),
                        }),
                    onOpen: () =>
                        trackEvent('Viewed Categories Product Selection Modal', {
                            fullscreen_overlay_id: modal.getAttribute('data-fullscreen-overlay-id'),
                        }),
                },
            })
    );
}

function updateColor() {
    const activeCategoryGroup = Array.from(
        document.querySelectorAll('[data-category-group]')
    ).filter(group => {
        return group.hasAttribute('data-active');
    })[0];

    const activeCarouselItem = activeCategoryGroup.querySelector(
        '[data-slide-carousel-content][data-carousel-active=true]'
    );
    const colorHex = activeCarouselItem.querySelector('[data-color]').getAttribute('data-color');

    Array.from(document.querySelectorAll('[data-categories-chameleon-element]')).forEach(
        element => {
            element.style.color = colorHex;
        }
    );
}

function initializeCarousel() {
    const galleries = document.querySelectorAll('[data-slide-carousel]');

    Array.from(galleries).forEach(gallery => {
        new SlideCarousel({
            element: gallery,
            stepElement: gallery.querySelector('[data-carousel-steps]'),
            stepClickEventMessage: 'Clicked Gallery Control On Categories Page',
        });

        gallery.addEventListener('click', updateColor);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        new ScrollToElement(element).handleClick();
        element.addEventListener('click', () => {
            document.querySelector('[data-search-field]').focus();
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const modalCtas = document.querySelectorAll(
        '[data-fullscreen-overlay-id] [data-categories-cta]'
    );

    Array.from(modalCtas).forEach(element => {
        trackLink(element, 'Clicked CTA on Categories Page', {
            cta_location: element.getAttribute('data-categories-cta-location'),
            cta_category: element.getAttribute('data-categories-cta-category'),
        });
    });
});



// WEBPACK FOOTER //
// ./js/marketing/categories.js